import {styled} from '@mui/material/styles';
import React from 'react';

import CustomButtonGroup from '../../components/CustomButtonGroup/CustomButtonGroup';
import CustomError from '../../components/CustomError/CustomError';
import {logOutUser} from '../../utils/helper';

const StyledWrapperDiv = styled('div')(({theme}) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  height: '100vh',
  width: '100%',
  backgroundColor: theme.palette.grey[200],
}));

const StyledWrapperInnerDiv = styled('div')(({theme}) => ({
  display: 'flex',
  flexWrap: 'wrap',
  '& > *': {
    flex: `1 1 100%`,
  },
  '& .custom-button-group': {
    maxWidth: 300,
    margin: 'auto',
  },
}));

function ErrorPage({message}) {
  const onLogout = () => {
    logOutUser();
  };
  return (
    <StyledWrapperDiv>
      <StyledWrapperInnerDiv>
        <CustomError message={message} size="large" />
        <CustomButtonGroup
          first={{
            text: 'Logout',
            variant: 'outlined',
            onClick: onLogout,
          }}
          second={{
            text: 'Go Back',
            variant: 'contained',
            onClick: () => {
              window.history.back();
            },
          }}
        />
      </StyledWrapperInnerDiv>
    </StyledWrapperDiv>
  );
}

export default ErrorPage;
